export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/book_ebook_marketing.54177e9.svg";